"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_MESSAGE_CODE = { key: '', cssClass: '' };
//# sourceMappingURL=constants.js.map